/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AlarmActivation,
  AlarmActivation$inboundSchema,
} from "./alarmactivation.js";

export type ListHistoricalAlarmActivationsResponseBody = {
  /**
   * Cursor to retrieve the next page of historical activations if applicable. If not applicable, this field will not be present.
   */
  nextCursor?: string | undefined;
  /**
   * Cursor to retrieve the previous page of historical activations if applicable. If not applicable, this field will not be present.
   */
  previousCursor?: string | undefined;
  /**
   * List of historical alarm activations
   */
  values: Array<AlarmActivation>;
};

/** @internal */
export const ListHistoricalAlarmActivationsResponseBody$inboundSchema:
  z.ZodType<ListHistoricalAlarmActivationsResponseBody, z.ZodTypeDef, unknown> =
    z.object({
      next_cursor: types.optional(types.string()),
      previous_cursor: types.optional(types.string()),
      values: z.array(AlarmActivation$inboundSchema),
    }).transform((v) => {
      return remap$(v, {
        "next_cursor": "nextCursor",
        "previous_cursor": "previousCursor",
      });
    });

export function listHistoricalAlarmActivationsResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<
  ListHistoricalAlarmActivationsResponseBody,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ListHistoricalAlarmActivationsResponseBody$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'ListHistoricalAlarmActivationsResponseBody' from JSON`,
  );
}
